var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['loading_area', _vm.mode]},[_c('transition',{attrs:{"name":"custom-classes-transition","enter-active-class":"animated flipInY","leave-active-class":"animated flipOutY"}},[(_vm.show)?_c('div',[_c('img',{staticClass:"_logo",attrs:{"src":_vm.logo}}),_c('h5',{class:[_vm.mode === 'page' ? 'text-light' : 'text-dark', 'mt-2']},[_vm._v("loading")])]):_vm._e()])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a8c141b","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
// module id = null
// module chunks = 